import { Link } from 'react-router-dom';
import  { useEffect } from "react";

import { useMedia } from "react-media";

import { useQuery } from "react-query";
import styled from "styled-components";
import { getNewsItems } from "../../api/api";
import {
  GLOBAL_MEDIA_QUERIES,

} from "../../constatnts";
import { INews } from "../../types/news";
import { IMedia } from "../../types/types";
import { useTranslation } from "react-i18next";
import { SectionTitle, SubTitle, Title } from "../common";


const News = ({ limit = 3 }) => {
  const { t, i18n } = useTranslation();

  const matches = useMedia({ queries: GLOBAL_MEDIA_QUERIES });
  const { isLoading, error, data,  refetch }: any = useQuery("NewsData", () =>
    getNewsItems({ limit, language: i18n.language })
  );


  useEffect(() => {
    refetch();
  }, [i18n.language]);

  if (isLoading) return <div></div>;
  if (error) return <div></div>;
  return (
    <Container id="news" {...matches}>
                <h4 className="shape-round mb-lg-5 pb-5">أخبار الشركة</h4>


      <NewsContainer {...matches}>
        {data.data.map((newsItem: INews) => (
          <NewsItem data={newsItem} />
        ))}
      </NewsContainer>
      {/* <ReactJson src={data.data} /> */}
    </Container>
  );
};

interface ISNewsItemProps {
  data: INews;
}

const NewsItem = (props: ISNewsItemProps) => {
  return (
    <SLink to={`/news-list/${props.data.id}`}>
      <ServiceItemContainer>
        <NewsImage
          src={`${process.env.REACT_APP_CMS}${props?.data?.Images[0]?.url}`}
        />
        <Title>{props.data.Title}</Title>
        <SubTitle>{props.data.SubTitle}</SubTitle>
      </ServiceItemContainer>
    </SLink>
  );
};

interface INewsImageProps {
  src: string;
}
const NewsImage = styled.div<INewsImageProps>`
  width: 100%;
  height: 300px;
  border-radius: 3px;
  background-size: cover;
  background-image: url(${({ src }) => (src ? src : "")});
`;


const SLink = styled(Link)`
  text-decoration: none;
`;

const Container = styled.div<IMedia>`
  margin: ${(props) => (props.small ? "0px 10px" : "0px 40px")};
  line-height: 1.3em;
 
`;

const NewsContainer = styled.div<IMedia>`
  display: grid;
  grid-template-columns: ${(props) => (props.large ? "1fr 1fr 1fr" : "1fr")};
  grid-column-gap: 30px;
  grid-row-gap: 30px;
`;
const ServiceItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: flex-start;
  padding: 10px;
  border-radius: 5px;
  transition: 0.3s;
  background: #ffffff;
  border-radius: 5px;
  min-height: 500px;
  box-shadow: 0 0 11px 0 rgba(0, 0, 0, 0.09);
  transition: 500ms;
  &:hover {
    /* background-color: rgba(0, 0, 0, 0.055); */
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
  }
`;


const Icon = styled.img`
  width: 60px;
`;

export default News;
